import React, { useEffect, useRef, useState } from "react";
import Logo from "../assets/images/logo.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PrimaryButton from "../shared/components/CustomButtons";
import { isAuthenticated, logout } from "../shared/services/auth";
import { Menu } from "primereact/menu";
import { Avatar } from "primereact/avatar";
import { useDispatch, useSelector } from "react-redux";
import { getProfileAction } from "../store/actions/user.actions";
import { fetchServices } from "../store/slices/servicesSlice";
import constants from "../constants";
import { OverlayPanel } from "primereact/overlaypanel";
import { TabMenu } from "primereact/tabmenu";
import { socket } from "../socket";
import {
  fetchUnreadNotificationsCount,
  fetchUserNotifications,
  markNotificationAsRead,
} from "../store/slices/userSlice";
import moment from "moment";
import SupportImg from "../assets/icon/support1.svg";
import { getImageUrl, slugify } from "../utils/commonFunctions";

export default function Topbar() {
  let { notifications } = useSelector((state) => state.user);
  const { unreadNotificationsCount } = useSelector((state) => state.user);
  const { profile } = useSelector((state) => state.user);
  const { services } = useSelector((state) => state.service);

  const [activeIndex, setActiveIndex] = useState(0);
  const notificationMenu = [
    { label: "All" },
    { label: `Unread(${unreadNotificationsCount})` },
  ];
  const location = useLocation();

  const [filteredNotifications, setFilteredNotifications] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMenuOpen, setMenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const handleNavigation = (path) => {
    setMenuOpen(false); // Close the menu if it's open
    setTimeout(() => {
      window.scrollTo(0, 0); // Ensure page scrolls to top
      navigate(`/${path}`);
    }, 100);
  };
  const menuItems = [
    {
      title: "Services",
    },
    {
      title: "Contact",
      link: "/contact",
    },
  ];
  const op = useRef(null);
  const menu = useRef(null);
  // Menu items for user profile dropdown
  const items = [
    // { label: "Profile", icon: "pi pi-user", command: () => null },
    // { separator: true },
    {
      template: () => {
        return (
          <Link
            to="/contact"
            className="inline-flex text-gray-700 no-underline align-items-center gap-1"
            style={{ padding: "12px 20px" }}
          >
            <img src={SupportImg} alt="" width={20} />
            <span className="font-normal text-base ">Help and support</span>
          </Link>
        );
      },
    },

    {
      label: "Logout",
      icon: "pi pi-power-off",
      command: () => logout(() => navigate("/auth/login")),
    },
  ];

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };
  const closeMenu = () => {
    setMenuOpen(false);
  };

  const toggleSubMenu = (index) => {
    setActiveMenu(activeMenu === index ? null : index);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (isAuthenticated()) {
      dispatch(getProfileAction());
      dispatch(fetchUnreadNotificationsCount());
      dispatch(fetchUserNotifications(setFilteredNotifications));
    }
    dispatch(fetchServices());
  }, [dispatch]);

  useEffect(() => {
    socket.on("notifications", () => {
      dispatch(fetchUnreadNotificationsCount());
      dispatch(fetchUserNotifications());
    });
  }, [socket.connected]);

  const onNotificationTabChange = (e) => {
    setActiveIndex(e.index);
    if (e.index) {
      const filterNotifications = notifications?.filter((item) => !item.isRead);
      setFilteredNotifications([...filterNotifications]);
    } else {
      setFilteredNotifications([...notifications]);
    }
  };

  const markAsRead = (id) => {
    dispatch(markNotificationAsRead({ id, setData: setFilteredNotifications }));
  };

  useEffect(() => {
    dispatch(fetchUserNotifications(setFilteredNotifications));
  }, [dispatch, unreadNotificationsCount]);


  return (
    <div
      className={`topbar w-full py-3 shadow-3 ${isScrolled ? "fixed-header" : ""
        }`}
    >
      <div className="container flex justify-content-between align-items-center">
        <Link
          to="/home"
          className="no-underline"
          onClick={() => window.scrollTo(0, 0)}
        >
          <img className="cursor-pointer" src={Logo} alt="Logo" />
        </Link>
        <div className="flex align-items-center gap-3">
          {isAuthenticated() ? (
            <div className="flex">
              <div
                className={`menu-bar z-2 mr-8 ${isMenuOpen ? "menu-show" : ""}`}
              >
                <ul className="p-0 flex flex-column lg:flex-row gap-6 lg:align-items-center list-none">
                  <li>
                    <Link
                      className={`no-underline font-medium block ${location?.pathname === "/home"
                        ? "primary-color"
                        : "sub-heading"
                        }`}
                      to="/home"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link
                      className={`no-underline font-medium block ${location?.pathname.includes("/dashboard")
                        ? "primary-color"
                        : "sub-heading"
                        }`}
                      to="/dashboard/home"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      Dashboard
                    </Link>
                  </li>
                  {menuItems.map((item, index) => (
                    <li
                      key={index}
                      onClick={() =>
                        item.title === "Services"
                          ? toggleSubMenu(index)
                          : null && closeMenu()
                      }
                      className="relative"
                    >
                      <Link
                        className={`no-underline ${location?.pathname ===
                          `/${item.title.toLocaleLowerCase()}`
                          ? "primary-color"
                          : "sub-heading"
                          }`}
                        to={item.link}
                      >
                        {item.title}
                      </Link>
                      {/* 1 */}
                      {activeMenu === index && (
                        <div className="lg:fixed z-2  w-full top-0 h-full left-0 activemenu">
                          <div
                            className={` z-1 w-10 show-sub-menu lg:fixed top-full lg:shadow-2 bg-white p-2 lg:px-6 lg:py-4 `}
                          >
                            <div className="grid">
                              {services?.length > 0 ? services?.map((service, index) => (
                                <div className="lg:col-6" key={index}>
                                  <Link
                                    // to={"/service/" + slugify(service.serviceName)}
                                    to={`${service?.serviceType === "3DRENDERS"
                                      ? `/3Dservices/${slugify(
                                        service.serviceName
                                      )}`
                                      : `/service/${slugify(
                                        service.serviceName
                                      )}`
                                      }`}
                                    className="flex gap-3 align-items-center no-underline"
                                    onClick={() => {
                                      window.scrollTo(0, 0);
                                    }}
                                  >
                                    <img
                                      src={
                                        constants.baseUrl + service?.iconImage
                                      }
                                      alt={service?.iconImage}
                                      width={40}
                                    />
                                    <div className="">
                                      <h3 className="heading text-lg font-semibold mb-1">
                                        {service?.serviceName}
                                      </h3>
                                      <p className="text-gray-color text-sm font-normal m-0">
                                        {service?.serviceDescription}
                                      </p>
                                    </div>
                                  </Link>
                                </div>
                              )) : <p>No services are available.</p>}
                            </div>
                          </div>
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex gap-3 align-items-center">
                <div className="relative">
                  <i
                    className="pi pi-bell text-xl cursor-pointer"
                    onClick={(e) => op.current.toggle(e)}
                  />
                  {unreadNotificationsCount ? (
                    <div
                      className="unread-dot border-circle bg-red-500 absolute top-0 right-0"
                      style={{ width: "9px", height: "9px" }}
                    ></div>
                  ) : null}
                </div>
                <OverlayPanel
                  ref={op}
                  className="w-10 lg:w-4 notification-overlay"
                >
                  <div className="flex justify-content-between gap-2">
                    <h3 className="m-0 text-black-alpha-90">Notification</h3>
                    <i
                      className="pi pi-times cursor-pointer"
                      onClick={(e) => op.current.toggle(e)}
                    ></i>
                  </div>
                  <TabMenu
                    className="notification-tabs-view"
                    model={notificationMenu}
                    activeIndex={activeIndex}
                    onTabChange={(e) => onNotificationTabChange(e)}
                  />
                  <>
                    <ul className="notification-list p-0">
                      {filteredNotifications?.length ? (
                        filteredNotifications.map((notification) => (
                          <li
                            key={notification._id}
                            className="flex align-items-center gap-3 justify-content-between mb-4 cursor-pointer"
                            onClick={() => markAsRead(notification._id)}
                          >
                            <div className="flex align-items-center gap-2">
                              <div
                                className="flex justify-content-center align-items-center bg-gray-300 border-circle"
                                style={{ minWidth: "47px", minHeight: "47px" }}
                              >
                                <i className="pi pi-bell text-red-500 text-xl"></i>
                              </div>
                              <div className="w-10">
                                <p className="text-lg my-1">
                                  {notification?.desc}
                                </p>
                                <small className="text-gray">
                                  {moment(notification?.time).format(
                                    "MMM DD, YYYY | h:mmA"
                                  )}
                                </small>
                              </div>
                            </div>
                            {!notification?.isRead && (
                              <div
                                className="unread-dot border-circle bg-red-500"
                                style={{ minWidth: "9px", height: "9px" }}
                              ></div>
                            )}
                          </li>
                        ))
                      ) : (
                        <div className="text-center py-4 text-gray-500">
                          <i className="pi pi-bell text-3xl mb-2 block"></i>
                          <p className="m-0">No notifications yet</p>
                          <small>
                            You'll see updates here once your activity begins.
                          </small>
                        </div>
                      )}
                    </ul>
                  </>
                </OverlayPanel>
                {profile.image ? (
                  <Avatar
                    image={getImageUrl(profile.image)}
                    size="large"
                    shape="circle"
                  />
                ) : (
                  <Avatar
                    label={profile?.fullName?.charAt(0)}
                    size="large"
                    shape="circle"
                  />
                )}
                {/* User Name and Down Arrow */}
                <div
                  className="p-d-flex p-ai-center flex gap-2 align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={(event) => menu.current.toggle(event)}
                >
                  {/* Display user name */}
                  <span className="p-mr-1 hidden md:block inter">
                    {profile?.fullName}
                  </span>

                  {/* Down Arrow icon */}
                  <i className="pi pi-chevron-down" aria-hidden="true"></i>
                </div>

                {/* Dropdown Menu */}
                <Menu model={items} popup ref={menu} id="user_menu" />
              </div>
            </div>
          ) : (
            <>
              <div className={`menu-bar z-2 ${isMenuOpen ? "menu-show" : ""}`}>
                <ul className="p-0 flex flex-column lg:flex-row gap-6 lg:align-items-center list-none">
                  <li onClick={closeMenu}>
                    <Link
                      className="no-underline primary-color font-medium block lg:hidden"
                      to="/home"
                    >
                      Home
                    </Link>
                  </li>
                  {menuItems.map((item, index) => (
                    <li
                      key={index}
                      onClick={() => toggleSubMenu(index)}
                      className="relative"
                    >
                      <Link
                        className={`no-underline ${(location?.pathname === `/${item.title.toLocaleLowerCase()}`) ? "primary-color" : "sub-heading"}`}
                        to={item.link}
                        onClick={() =>
                          item.title === "Services"
                            ? toggleSubMenu(index)
                            : closeMenu()
                        }
                      >
                        {item.title}
                      </Link>
                      {/* 2 */}
                      {(activeMenu === 0) ? (
                        <div className="lg:fixed z-2  w-full top-0 h-full left-0 activemenu">
                          {/* <div className="show-sub-menu z-1 lg:fixed top-full lg:shadow-2 bg-white p-2 lg:px-6 lg:py-4"> */}

                          <div className="z-1 w-10 show-sub-menu lg:fixed top-full lg:shadow-2 bg-white p-2 lg:px-6 lg:py-4">
                            <div className="grid">
                              {services.length > 0 ? services?.map((service, index) => (
                                <div className="lg:col-6" key={index}>
                                  <Link
                                    // to={"/3Dservices/" + slugify(service.serviceName)}
                                    to={`${service?.serviceType === "3DRENDERS"
                                      ? `/3Dservices/${slugify(
                                        service.serviceName
                                      )}`
                                      : `/service/${slugify(
                                        service.serviceName
                                      )}`
                                      }`}
                                    onClick={closeMenu}
                                    className="flex gap-3 align-items-center no-underline"
                                  >
                                    <img
                                      src={
                                        constants.baseUrl + service?.iconImage
                                      }
                                      alt={service?.iconImage}
                                      width={40}
                                    />
                                    <div className="">
                                      <h3 className="heading text-lg font-semibold mb-1">
                                        {service?.serviceName}
                                      </h3>
                                      <p className="text-gray-color text-sm font-normal m-0">
                                        {service?.serviceDescription}
                                      </p>
                                    </div>
                                  </Link>
                                </div>
                              )) : <p>No services are available.</p>}
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </li>
                  ))}
                  <li onClick={closeMenu}>
                    <Link
                      // className="no-underline primary-color font-medium"
                      className={`no-underline ${location?.pathname === `/auth/register`
                        ? "primary-color"
                        : "sub-heading"
                        }`}
                      to="/auth/register"
                    >
                      Register
                    </Link>
                  </li>
                  <li onClick={closeMenu}>
                    <Link to="/auth/login">
                      <PrimaryButton
                        label="Login"
                        extraClassNames="lg:w-8rem"
                      />
                    </Link>
                  </li>
                </ul>
              </div>
            </>
          )}
          <i
            className="pi pi-bars text-dark text-2xl cursor-pointer block lg:hidden"
            onClick={toggleMenu}
          ></i>
        </div>
      </div>
    </div>
  );
}
